// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface AwsVPC
 */
export interface AwsVPC {
  /**
   *
   * @type {string}
   * @memberof AwsVPC
   */
  cidrBlock?: string;
}

/**
 * Check if a given object implements the AwsVPC interface.
 */
export function instanceOfAwsVPC(value: object): value is AwsVPC {
  return true;
}

export function AwsVPCFromJSON(json: any): AwsVPC {
  return AwsVPCFromJSONTyped(json, false);
}

export function AwsVPCFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AwsVPC {
  if (json == null) {
    return json;
  }
  return {
    cidrBlock: json['cidr_block'] == null ? undefined : json['cidr_block'],
  };
}

export function AwsVPCToJSON(json: any): AwsVPC {
  return AwsVPCToJSONTyped(json, false);
}

export function AwsVPCToJSONTyped(
  value?: AwsVPC | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    cidr_block: value['cidrBlock'],
  };
}
